import TemplateView from '../../../../TemplateView'

export default class TableHeader extends TemplateView {
    constructor() {
        super()

        this.state = {
            showOvertime: false,
            showLeave: false,
        }

        this.onStatePropertyChanged('showOvertime', showOvertime => this.$overtimeRateColumn.toggle(showOvertime))
        this.onStatePropertyChanged('showLeave', showLeave => this.$leaveRatesColumn.toggle(showLeave))
    }

    templateHtml() {
        return '<div class="userRatesTableHeader">' +
               '    <div class="regularRateColumn headerColumn"><%-regularRate%></div>' +
               '    <div class="overtimeRateColumn headerColumn"><%-overtimeRate%></div>' +
               '    <div class="leaveRatesColumn headerColumn"><%-leaveRates%></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            regularRate: 'user.add_edit.js.rates_editor.regular_rate_column_title',
            overtimeRate: 'user.add_edit.js.rates_editor.overtime_rate_column_title',
            leaveRates: 'user.add_edit.js.rates_editor.leave_rates_column_title',
        }
    }

    afterRender() {
        this.$overtimeRateColumn = this.find('.overtimeRateColumn')
        this.$leaveRatesColumn = this.find('.leaveRatesColumn')

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/TableHeader.js